const BreadcrumbItem = () => {
  return [
    {
      title: `Dashboard`,
      path: `/dashboard`,
      isActive: false
    },
    {
      title: `Claims management`,
      path: ``,
      isActive: true
    }
  ];
};

export default BreadcrumbItem;
